import React from "react";
import { graphql, QueryRenderer } from "react-relay";
import environment from "./Environment";
import { GC_USER_ID } from "./constants";
import { commitLocalUpdate } from "react-relay";
import { createOperationDescriptor, getRequest } from "relay-runtime";
import Spinner from "./Spinner";
import IncompletePaymentPage from "./IncompletePaymentPage";
import ThemeProvider from "./contexts/ThemeContext";

const userDetailsQuery = graphql`
	query IncompletePaymentPageContainer_UserDetails_Query($id: ID!) {
		user(id: $id) {
			email
			is_premium
			is_active
			currency
		}
		settings {
			isAuthenticated
			userId
			isNavActivated
			selectedSourceId
			selectedParentId
			treeStates
			selectedNodeId
			isParent
		}
	}
`;

const request = getRequest(userDetailsQuery);
const operation = createOperationDescriptor(request, {} /* variables */);

function createAuthDetails(id) {
	commitLocalUpdate(environment, store => {
		const record = store.getRoot().getLinkedRecord("settings");
		record.setValue(true, "isAuthenticated");
		record.setValue(id, "userId");
	});
}

function IncompletePaymentPageContainer(props) {
	let userId = localStorage.getItem(GC_USER_ID);
	createAuthDetails(userId);

	// useEffect(() => {
	// 	console.log("UserId from HomeViewWrapper(from useEffect): " + userId);
	// 	return () => {
	// 		// localStorage.removeItem(GC_USER_ID);
	// 		// localStorage.removeItem(GC_AUTH_TOKEN);
	// 	};
	// });

	return (
		<QueryRenderer
			environment={environment}
			fetchPolicy={"store-and-network"}
			query={userDetailsQuery}
			variables={{ id: userId }}
			render={({ error, props }) => {
				if (error) throw error;
				if (!props)
					return (
						<div>
							{" "}
							<Spinner isLoading={true} />{" "}
						</div>
					);
				return (
					<div>
						<ThemeProvider>
							<IncompletePaymentPage user={props.user} settings={props.settings} />
						</ThemeProvider>
					</div>
				);
			}}
		/>
	);
}

export default IncompletePaymentPageContainer;
